import { useState } from "react";

import { addDays, startOfDay } from "date-fns";

import { useCurrentUserContext } from "@/common/contexts/current-user-context/CurrentUserContext";
import { useAppointmentsQuery } from "@/common/hooks/useAppointmentsQuery";

interface DateRange {
  startDate: Date;
  endDate: Date;
}

export function useAppointments() {
  const { currentUser } = useCurrentUserContext();

  const [selectedCounselorId, setSelectedCounselorId] = useState<string | null>(currentUser.counselorId ?? "");
  const [dateRange, setDateRange] = useState<DateRange>(() => ({
    startDate: startOfDay(new Date()),
    endDate: startOfDay(addDays(new Date(), 1)),
  }));

  const { calendarAppointments, isLoading } = useAppointmentsQuery({
    startDate: dateRange.startDate,
    endDate: dateRange.endDate,
    counselorId: selectedCounselorId,
  });

  const onDateRangeChange = (start: Date, end: Date) => {
    setDateRange({ startDate: start, endDate: end });
  };

  const onCounselorChange = (counselor: string | null) => {
    setSelectedCounselorId(counselor);
  };

  return {
    appointments: calendarAppointments,
    isLoading,
    onDateRangeChange,
    selectedCounselorId,
    onCounselorChange,
  };
}
